<template>
  <m-product-offer1 :offer-status="offerStatus" :offer-type="offerType" class="position-absolute" :product="product"/>
  <m-card309 :image="product.thumbnail" :alt="product.name"
             :image-link="{name:'Product',params:{name:product.raw_link}}" class="border product-card-309 rounded mb-2">

    <div class="col-lg-12 text-center">
      <m-a class="text-decoration-none" :href="{name:'Product',params:{name:product.raw_link}}">
        <h1 class="h6 my-1">{{ product.name }}</h1>
      </m-a>

      <m-product-price100 class="text-center" :product="product"/>
      <m-product-card-quantity-manager1 class="text-center" :product="product"/>


    </div>

  </m-card309>
</template>

<script>
import {shoppingCartFunctions} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions'
import mCard309 from "../../Cards/Card309";
import mA from '../../Tags/A'
import mProductCardQuantityManager1 from "../../Product/QuantityManager/Card/ProductCardQuantityManager1";
import mProductPrice100 from "../../Product/ProductPrice100";
import mProductOffer1 from "../../Product/ProductOffer/ProductOffer1";
import {OfferProps} from '../ProductOffer/ProductOfferProps'

export default {
  name: "ProductCard3",
  components: {mCard309, mA, mProductCardQuantityManager1, mProductPrice100, mProductOffer1},
  props: {
    product: {},
    ...OfferProps,
  },
  methods: {
    ...shoppingCartFunctions,
  }
}
</script>

<style scoped>

</style>